function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import delay from 'lodash/delay';
import FormContainerAbstract from 'components/FormContainerAbstract';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Button from 'components/Form/Button';
import ButtonsContainer from 'components/Form/ButtonsContainer';
import App from 'modules/App';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import validatorRules from './validatorRules.json';
class SetNewPasswordCCForm extends FormContainerAbstract {
    static getDerivedStateFromProps(props, state) {
        const { isInProgress, hasErrors } = props;
        if (isInProgress && !state.isInProgress) {
            return {
                isInProgress: true
            };
        }
        if (hasErrors && state.isInProgress) {
            return {
                isInProgress: false
            };
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        const { isInProgress, hasErrors } = this.props;
        if (prevProps.isInProgress && !isInProgress && !hasErrors && this.props.onSuccess) {
            delay(()=>this.props.onSuccess(), 100); // delay for service bus propagation
        }
    }
    renderSubmitBtn() {
        return /*#__PURE__*/ _jsx("div", {
            className: "col-12 col-sm-6",
            children: /*#__PURE__*/ _jsx(Button, {
                type: "submit",
                styleModifier: "primary",
                labelMessage: messages.buttons.setNewPassword,
                className: "btn--block btn--filled",
                isInProgress: this.state.isInProgress
            })
        });
    }
    renderActionsContent() {
        return /*#__PURE__*/ _jsx("div", {
            className: "row",
            children: this.renderSubmitBtn()
        });
    }
    renderActions() {
        if (this.props.isOneLiner) {
            return /*#__PURE__*/ _jsx(ButtonsContainer, {
                children: this.renderActionsContent()
            });
        }
        return this.renderActionsContent();
    }
    renderField(id, { labelMessage } = {}) {
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: id,
            labelMessage: labelMessage || messages.labels[id],
            infoMessage: messages.fieldsInfos[id],
            formValues: this.props.formValues,
            isOneLiner: this.props.isOneLiner,
            children: /*#__PURE__*/ _jsx(Input, {
                type: "password",
                placeholder: messages.placeholders[id],
                attributes: {
                    autoComplete: 'new-password'
                },
                onChange: (input)=>this.onSetValue(input)
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Form, {
            onSubmit: ()=>this.onSubmit(),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        !this.props.temporaryPassword && this.renderField('temporaryPassword'),
                        this.renderField('password', {
                            labelMessage: messages.labels.newPassword
                        })
                    ]
                }),
                this.renderActions()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isInProgress: false
        };
        this.validatorRules = _object_spread({}, validatorRules);
        const { temporaryPassword } = props;
        if (temporaryPassword) {
            props.onSetFormValues({
                temporaryPassword
            });
        }
    }
}
_define_property(SetNewPasswordCCForm, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit props
    email: PropTypes.string.isRequired,
    identityProviderKey: PropTypes.string.isRequired,
    temporaryPassword: PropTypes.string,
    isOneLiner: PropTypes.bool,
    // Explicit actions
    onSuccess: PropTypes.func,
    // Implicit props
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool
}));
const mapStateToProps = (state)=>({
        isInProgress: selectors.isResetPasswordCCInProgress(state),
        hasErrors: selectors.hasResetPasswordCCErrors(state),
        formValues: App.selectors.formSelector(constants.SET_PASSWORD_FORM)(state)
    });
const mapDispatchToProps = (dispatch, props)=>{
    const { email, identityProviderKey } = props;
    const formName = constants.SET_PASSWORD_FORM;
    return {
        onSubmit: (values)=>dispatch(actions.setNewPasswordCC(_object_spread_props(_object_spread({}, values), {
                email,
                identityProviderKey
            }))),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedSetNewPasswordCCForm = connect(mapStateToProps, mapDispatchToProps)(SetNewPasswordCCForm);
export default ConnectedSetNewPasswordCCForm;
